import { GetOneElementOutDto, GetOneElementInDto } from '../../../types/element.dto'

export const GET_ONE_ELEMENT = 'GET_ONE_ELEMENT'
export const GET_ONE_ELEMENT_SUCCESS = 'GET_ONE_ELEMENT_SUCCESS'
export const GET_ONE_ELEMENT_ERROR = 'GET_ONE_ELEMENT_ERROR'
export const RESET_GET_ONE_ELEMENT = 'RESET_GET_ONE_ELEMENT'

export interface GetOneElement<T> {
  type: typeof GET_ONE_ELEMENT
  payload: GetOneElementOutDto<T>
}

export interface GetOneElementSuccess<T> {
  type: typeof GET_ONE_ELEMENT_SUCCESS
  payload: GetOneElementInDto<T>
}

export interface GetOneElementError {
  type: typeof GET_ONE_ELEMENT_ERROR
  payload: string | boolean
}

export interface ResetGetOneElement {
  type: typeof RESET_GET_ONE_ELEMENT
  payload: null
}

export interface State<T> {
  data: GetOneElementInDto<T> | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

// Define una función que acepte un parámetro T y devuelva un initialState con ese tipo T
const createInitialState = <T>(): State<T> => {
  return {
    data: null,
    states: {
      loading: false,
      success: false,
      error: false,
    },
  };
};

// Ahora puedes usar esta función para inicializar el estado con el tipo T que necesites
export const initialState = createInitialState<any>();

export type Actions<T> = GetOneElement<T> | GetOneElementSuccess<T> | GetOneElementError | ResetGetOneElement
